@for (comment of comments; track trackComment($index, comment)) {
  <div class="comment">
    @if (!(isSolo$ | async) || !isSolo) {
      <div
        [ngClass]="{ me: comment.authorId === me }"
        class="avatar"
        >
        @if (comment.authorId === me) {
          <span
            forceContext="comments"
            translate
            >organizationMemberYou</span
            >
          } @else {
            <span>{{
              comment.authorId
              | getOrganizationMemberName
              | async
              | nameAvatarGenerator
            }}</span>
          }
        </div>
      }
      <div class="content">
        <div class="container">
          @if (!(isSolo$ | async) || !isSolo) {
            <div class="author">
              @if (comment.authorId === me) {
                <span
                  forceContext="comments"
                  translate
                  >organizationMemberYou</span
                  >
                } @else {
                  <span>{{
                    comment.authorId | getOrganizationMemberName | async
                  }}</span>
                }
              </div>
            }
            <div
              [commentDate]="comment.date"
              [emitOnEntrance]="oldestVisibleCommentDate"
              [innerHTML]="comment.comment"
              class="text"
              libMarkCommentAsRead
            ></div>
          </div>
          <div
      [matTooltip]="
        comment.date * 1000
          | dateTimeFromMilliseconds
          | dateTimeToJsDate
          | date: 'medium'
      "
            class="date"
            >
            {{ comment.date * 1000 | dateTimeFromMilliseconds | dateTimeToRelative }}
          </div>
        </div>
      </div>
    }
